export default "__VITE_ASSET__efd33565__"